import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const LogoDiv = styled.div`
  cursor: pointer;

  img {
    height: 35px;
    width: auto;
  }
`;

const LOGO_FILE = {
  generic: "images/logo-experimental-small.png",
  allot: "images/logo-allot-small.png",
  cambium: "images/logo-cambium-big.png",
  viewtinet: "images/logo-viewtinet-small.png",
  "gs-kr": "images/logo-generic-small.png",
};
const LOGO_FILE_DARK = {
  generic: "images/logo-experimental-small-dark.png",
  allot: "images/logo-allot-small.png",
  cambium: "images/logo-cambium-big-dark.png",
  viewtinet: "images/logo-viewtinet-small.png",
  "gs-kr": "images/logo-generic-small.png",
};

export function Logo({ platform = "generic" }) {
  const navigate = useNavigate();
  const isDark = login.isTheme("dark");

  return (
    <LogoDiv
      className="navbar-brand-experimental"
      onClick={() => navigate("/viewDashboard")}
    >
      {!isDark && <img src={LOGO_FILE[platform]} alt="logo" />}
      {isDark && (
        <img src={LOGO_FILE_DARK[platform]} alt="logo" />
      )}
    </LogoDiv>
  );
}
